import React, { type FC, type HTMLAttributes } from "react";
import { graphql, useStaticQuery } from "gatsby";
import {DownloadFile} from "../DownloadFile";
import * as styles from "./Downloads.module.scss";

interface Props extends HTMLAttributes<HTMLElement> {
	node?: Queries.DownloadsDataFragment;
}

export const Downloads: FC<Props> = ({ node, ...rest }) => {

    if (!node?.relationships?.field_downloads?.length) {
        return null;
    }

    return (
        <div {...rest} className={styles.component}>
            <h2>Available Downloads</h2>
            <div className={styles.downloadsList}>
            {node.relationships.field_downloads.map(download => {
                if (!download) return null;

                const label = download.field_download_label || download.name || "";
                const file = download.relationships?.field_media_file;

                if (!file) return null;

                return (
                    <div className={styles.downloadItem}>
                        <DownloadFile
                            key={download.id}
                            pdf={[file]}
                            variant="main"
                            label={label}
                        />
                    </div>
                );
            })}
            </div>
        </div>
    );
};

export const fragment = graphql`
    fragment DownloadsData on paragraph__downloads {
        id
        __typename
        relationships {
            field_downloads {
                id
                name
                field_download_label
                relationships {
                    field_media_file {
                        id
                        filemime
                        filesize
                        filename
                        fields {
                            cdn_url
                        }
                    }
                }
            }
        }
    }
`;


export default Downloads;
